import { get } from '../../modules/scene';
import { initCamera } from '../camera';

export default function home(store, translator) {
  return {
    label: 'Home',
    enabled: true,
    display: {
      playerTools: true,
    },
    options: {},

    execute: () => {
      const playerData = get(store, { scene: true, evalPlug: 'Player' });
      initCamera(store, true, playerData && playerData.camera);
    },
  };
}



// WEBPACK FOOTER //
// ./src/translators/tools/home.js